import React, { useState, useMemo } from 'react';
import { Search, GetApp, FilterList } from '@mui/icons-material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TableSortLabel, TextField, InputAdornment, Pagination, Select, MenuItem, FormControl, Button } from '@mui/material';
import { eolConditionData, expiryDocumentsData } from './mockData';
import Paginationstat from './Paginationstat';
import '../styles/statistic.scss';


const EOLCondition = () => {
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(20);

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const filteredAndSortedData = useMemo(() => {
        let filtered = eolConditionData.filter((item) => {
            const matchesSearch =
                item?.documentType?.toLowerCase()?.includes(searchTerm.toLowerCase()) ||
                item?.documentName?.toLowerCase()?.includes(searchTerm.toLowerCase()) ||
                item?.expiryDate?.toLowerCase()?.includes(searchTerm.toLowerCase());

            return matchesSearch;
        });

        if (sortConfig.key) {
            filtered.sort((a, b) => {
                let aValue = a[sortConfig.key];
                let bValue = b[sortConfig.key];

                // Special handling for dollar values
                if (sortConfig.key === 'eolValue') {
                    aValue = parseFloat(aValue.replace(/[$,]/g, ''));
                    bValue = parseFloat(bValue.replace(/[$,]/g, ''));
                }

                // Special handling for percentage values
                if (sortConfig.key === 'eolMatch') {
                    aValue = parseFloat(aValue.replace('%', ''));
                    bValue = parseFloat(bValue.replace('%', ''));
                }

                if (aValue < bValue) {
                    return sortConfig.direction === 'asc' ? -1 : 1;
                }
                if (aValue > bValue) {
                    return sortConfig.direction === 'asc' ? 1 : -1;
                }
                return 0;
            });
        }

        return filtered;
    }, [searchTerm, sortConfig]);

    const paginatedData = useMemo(() => {
        const startIndex = (currentPage - 1) * rowsPerPage;
        return filteredAndSortedData.slice(startIndex, startIndex + rowsPerPage);
    }, [filteredAndSortedData, currentPage, rowsPerPage]);

    const handlePageChange = (event, newPage) => {
        setCurrentPage(newPage + 1);
    };

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setCurrentPage(1);
    };

    const handleExport = () => {
        alert('EOL Condition data exported successfully!');
    };

    const pagination = {
        total: filteredAndSortedData.length,
        per_page: rowsPerPage,
        page: currentPage
    };

    return (
        <div>
            <div className="stat-section-header">
                <h3 className="stat-section-title">EOL Condition</h3>
                <div className="stat-header-actions">
                    <TextField
                        size="small"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setCurrentPage(1);
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Search className="stat-search-icon" />
                                </InputAdornment>
                            ),
                            className: 'stat-search-input-slot'
                        }}
                        className="stat-search-field"
                    />
                    <Button startIcon={<ArrowDownwardIcon />} variant="outlined" size='small' className='btn-primary'> Export </Button>
                </div>
            </div>
            <TableContainer component={Paper} className="stat-table-container stat-table-container--max-333 lease-detail-table">
                <Table className="mui-table-format" stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell>EOL Condition Name</TableCell>
                            <TableCell>EOL Value</TableCell>
                            <TableCell>EOL Match %</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {paginatedData.map((row, index) => (
                            <TableRow key={row.id} >
                                <TableCell>{row.documentType}</TableCell>
                                <TableCell>{row.documentName}</TableCell>
                                <TableCell>{row.expiryDate}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <div className="stat-pagination-spacer">
                <Paginationstat
                    pagination={pagination}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={handleRowsPerPageChange}
                    stacks={[ 20, 50, 100]}
                />
            </div>
        </div>
    );
};

export default EOLCondition;